import { Columns } from '@shared/interfaces/table/column-config';
import { DateCellComponent } from '@shared/components/table/cells/date-cell/date-cell.component';
import { LinkCellComponent } from '@shared/components/table/cells/link-cell/link-cell.component';
import { datahubPartial } from '@shared/partials/datahub.partial';
import { electricalHeatingStatusPartial } from '@shared/partials/electricalheatingstatus.partial';

export const electricalHeatingDateColumn: Columns<any> = {
  title: 'dashboard.electricalheating.date',
  key: 'electricalHeatingDate',
  cellRenderer: DateCellComponent,
}

export const electricalHeatingE17Identification: Columns<any> = {
  title: 'dashboard.electricalheating.e17identification',
  key: 'e17Identification',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/meteringpoint',
    urlReference: 'e17Identification',
  }
}

export const electricalHeatingStatus: Columns<any> = {
  ... electricalHeatingStatusPartial
}

export const electricalHeatingDataHubStatus: Columns<any> = {
  ... datahubPartial,
  title: 'dashboard.electricalheating.e17datahubstatus',
  key: 'e17DataHubStatus',
}

export const electricalHeatingD14Identification: Columns<any> = {
  title: 'dashboard.electricalheating.d14identification',
  key: 'd14Identification',
  cellRenderer: LinkCellComponent,
  cellRendererParams: {
    url: '/meteringpoint',
    urlReference: 'd14Identification',
  }
}

export const electricalHeatingD14DataHubStatus: Columns<any> = {
  ... datahubPartial,
  title: 'dashboard.electricalheating.d14datahubstatus',
  key: 'd14DataHubStatus',
}

export const electricalHeatingColumns: Columns<any>[] = [
  electricalHeatingDateColumn,
  electricalHeatingE17Identification,
  electricalHeatingStatus,
  electricalHeatingDataHubStatus,
  electricalHeatingD14Identification,
  electricalHeatingD14DataHubStatus,
]
